// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  font-family: 'Arial', sans-serif;
  background-color: #000;
  color: #fff;
}
header {
  position: fixed;
  width: 100%;
  background-color: #383838;
  padding: 0;
  z-index: 100;
  top: 0;
}
nav ul {
  display: flex;
  list-style: none;
  justify-content: center;
}
nav ul li {
  margin: 0 20px;
}
nav ul li a {
  color: #fff;
  text-decoration: none;
  font-weight: bold;
  font-size: 22px;
}
nav ul li a.active {
  color: #e74c3c;
  font-weight: bold;
  font-size: 22px;
}
section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 60px;
}
h1 {
  font-family: 'Playfair Display', serif;
  margin: 0;
  padding: 25px;
  color: #a71f07;
  font-size: 56px;
}

@media (max-width: 1100px) {
  nav ul li a {
    font-size: 20px;
  }
  nav ul li a.active {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  h1 {
    margin: 0;
    padding: 20px;
    font-size: 45px;
  }
  nav ul {
    width: 80%;
    flex-wrap: wrap;
    justify-content: center;
    gap: 5px;
  }
  nav ul li {
    width: 25%;
    text-align: center;
    margin: 5px;
  }
  nav ul li a {
    font-size: 17px;
  }
  nav ul li a.active {
    font-size: 17px;
  }
}

@media (max-width: 370px) {
  nav ul li a {
    font-size: 14px;
  }
  nav ul li a.active {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,MAAM;AACR;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,sCAAsC;EACtC,SAAS;EACT,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,SAAS;IACT,aAAa;IACb,eAAe;EACjB;EACA;IACE,UAAU;IACV,eAAe;IACf,uBAAuB;IACvB,QAAQ;EACV;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  font-family: 'Arial', sans-serif;\n  background-color: #000;\n  color: #fff;\n}\nheader {\n  position: fixed;\n  width: 100%;\n  background-color: #383838;\n  padding: 0;\n  z-index: 100;\n  top: 0;\n}\nnav ul {\n  display: flex;\n  list-style: none;\n  justify-content: center;\n}\nnav ul li {\n  margin: 0 20px;\n}\nnav ul li a {\n  color: #fff;\n  text-decoration: none;\n  font-weight: bold;\n  font-size: 22px;\n}\nnav ul li a.active {\n  color: #e74c3c;\n  font-weight: bold;\n  font-size: 22px;\n}\nsection {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding-top: 60px;\n}\nh1 {\n  font-family: 'Playfair Display', serif;\n  margin: 0;\n  padding: 25px;\n  color: #a71f07;\n  font-size: 56px;\n}\n\n@media (max-width: 1100px) {\n  nav ul li a {\n    font-size: 20px;\n  }\n  nav ul li a.active {\n    font-size: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  h1 {\n    margin: 0;\n    padding: 20px;\n    font-size: 45px;\n  }\n  nav ul {\n    width: 80%;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 5px;\n  }\n  nav ul li {\n    width: 25%;\n    text-align: center;\n    margin: 5px;\n  }\n  nav ul li a {\n    font-size: 17px;\n  }\n  nav ul li a.active {\n    font-size: 17px;\n  }\n}\n\n@media (max-width: 370px) {\n  nav ul li a {\n    font-size: 14px;\n  }\n  nav ul li a.active {\n    font-size: 14px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
